export const diaperRadioData = [
  {
    title: 'Buy 1 Diaper',
    price: '₹599',
    strikePrice: '₹699',
    unitPrice: '₹599',
    id: '2',
  },
  {
    title: 'Pack of 3 Cloth Diapers',
    price: '₹1,197',
    strikePrice: '₹2,097',
    unitPrice: '₹399',
    id: '1',
    offerId: '5856',
  },
  {
    title: 'Pack of 5 Cloth Diapers',
    price: '₹1,797',
    strikePrice: '₹3,495',
    unitPrice: '₹359',
    id: '3',
    offerId: '7140',
  },
];

export const diaperRadioDataVarient2 = [
  {
    title: 'Buy 1 Diaper',
    price: '₹599',
    strikePrice: '₹699',
    unitPrice: '₹599',
    id: '2',
  },
  {
    title: 'Buy 2 Get 1 Free',
    price: '₹1,197',
    strikePrice: '₹2,097',
    unitPrice: '₹399',
    id: '1',
    offerId: '5856',
  },
  {
    title: 'Buy 3 Get 2 Free ',
    price: '₹1,797',
    strikePrice: '₹3,495',
    unitPrice: '₹359',
    id: '3',
    offerId: '7140',
  },
];

export const idToDetailDaiper = { 1: '5856', 3: '7140', 4: '7749' };

export const constantTexts = {
  one_diaper: 'Select any cloth diaper',
  three_diaper: 'Select any 3 cloth diapers',
  five_diaper: 'Select any 5 cloth diapers',
  two_cd_1diaper: 'Select any 2 cloth diapers',
};

export const coupon_names = {
  b2g1: 'DIAPERDEAL',
  b2g1New: 'DAYANDNIGHTDEAL',
  // b3g2: "B3G2",
  b3g2: 'B3G2Diaper',
};
